/**
 * SAP CONFIDENTIAL
 *
 * This software is confidential proprietary software licensed by SAP SE
 * and is not to be used, duplicated or disclosed to anyone without the
 * prior written permission of SAP.
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { CommonService } from '../../shared/services/common.service';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

export class ChangeOrganizationConfimationModalContext {
    public isFrom!: string;
    public data?: any;
}

@Component({
  selector: 'change-organization-confimation-modal',
  templateUrl: './change-organization-confirmation-modal.component.html',
  styleUrls: ['./change-organization.component.scss'],
  providers: [CommonService],
  encapsulation: ViewEncapsulation.None
})
export class ChangeOrganizationConfimationModalComponent implements OnInit {
  @Input() context!: ChangeOrganizationConfimationModalContext;
  @Output() closeModal: EventEmitter<any> = new EventEmitter();
  public param: any;
  public currentOrganization: any;
  public newOrganization: any;
  public genTypes: any = {};

  constructor(
    public bsModalRef: BsModalRef<ChangeOrganizationConfimationModalContext>,
    public commonService: CommonService,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    this.param = {
      value: this.context.data.orgUnitLbl
    };
    this.currentOrganization = this.context.data.currentOrganization;
    this.newOrganization = this.context.data.newOrganization;
  }

  public closeModalWindow() {
    this.closeModal.emit('closed');
    this.bsModalRef.hide();
  }

  public confirmChange() {
    this.closeModal.emit('confirmed');
    this.bsModalRef.hide();
  }

  public getTranslationWithKey(key: string) {
    return this.commonService.getTranslatedVal(key);
  }
}
